/** KA today board — Priority (green), Daily (yellow), Today's order (pink, pre-booked).
 *
 * Priority & Daily — placed same day AND deliver today.
 * Today's order — booked before today, must deliver today.
 */

export const PRIORITY_GREEN = {
  border: "#86EFAC",
  bg: "#F0FDF4",
  badge: "#166534",
};

export const DAILY_YELLOW = {
  border: "#FCD34D",
  bg: "#FFFBEB",
  badge: "#92400E",
};

export const TODAY_PINK = {
  border: "#F9A8D4",
  bg: "#FFF0F6",
  badge: "#BE185D",
};

export function isPriorityTodayOrder(order) {
  return order?.today_order_kind === "priority";
}

export function isDailyTodayOrder(order) {
  return order?.today_order_kind === "daily";
}

export function isPrebookedTodayOrder(order) {
  return order?.today_order_kind === "today";
}

function pipelineActive(order) {
  const status = order?.order_status || order?.status || "";
  return status !== "Completed" && status !== "Delivered" && !order?.is_done;
}

export function isPriorityTodayOrderActive(order) {
  return isPriorityTodayOrder(order) && pipelineActive(order);
}

export function isDailyTodayOrderActive(order) {
  return isDailyTodayOrder(order) && pipelineActive(order);
}

export function isPrebookedTodayOrderActive(order) {
  return isPrebookedTodayOrder(order) && pipelineActive(order);
}

export function todayOrderBadgeLabel(order) {
  const kind = order?.today_order_kind;
  if (kind === "priority") return "Priority";
  if (kind === "daily") return "Daily";
  if (kind === "today") return "Today's order";
  return "";
}

export function todayOrderBadgeClass(order) {
  const kind = order?.today_order_kind;
  if (kind === "priority") return "kitchen-dash-priority";
  if (kind === "daily") return "kitchen-dash-daily";
  if (kind === "today") return "kitchen-dash-today-order";
  return "";
}

export function todayOrderCardClass(order) {
  const kind = order?.today_order_kind;
  if (kind === "priority") return "kitchen-dash-card--priority";
  if (kind === "daily") return "kitchen-dash-card--daily";
  if (kind === "today") return "kitchen-dash-card--today-order";
  return "";
}

/** @deprecated use DAILY_YELLOW */
export const DAILY_AMBER = DAILY_YELLOW;
